import React, { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import SchoolItemContext from '../SchoolItemContext';

const SchoolItemLanguage = () => {
  const school = useContext(SchoolItemContext);
  const languages = [
    school?.school?.language1?.name,
    school?.school?.language2?.name,
    school?.school?.language3?.name,
  ];
  school?.school?.languages?.forEach(({ name }) => languages.push(name));
  return (
    <div className="school-item__languages">
      {languages.filter((l) => !!l).map((lang) => <span key={uuidv4()}>{lang}</span>)}
    </div>
  );
};

export default SchoolItemLanguage;
